import type { InputHTMLAttributes, SelectHTMLAttributes, TextareaHTMLAttributes } from 'react'

export const inputClass =
  'w-full rounded-input border border-border-strong bg-white px-3 py-2 text-sm text-ink placeholder:text-ink-faint focus:border-primary-700 focus:outline-none disabled:bg-sand disabled:text-ink-muted aria-[invalid=true]:border-danger'

export function Input({ className = '', ...rest }: InputHTMLAttributes<HTMLInputElement>) {
  return <input className={`${inputClass} ${className}`} {...rest} />
}

export function Textarea({ className = '', ...rest }: TextareaHTMLAttributes<HTMLTextAreaElement>) {
  return <textarea className={`${inputClass} min-h-24 ${className}`} {...rest} />
}

export function Select({ className = '', children, ...rest }: SelectHTMLAttributes<HTMLSelectElement>) {
  return (
    <select className={`${inputClass} ${className}`} {...rest}>
      {children}
    </select>
  )
}

/**
 * Input số nguyên VND: hiện có dấu chấm nghìn khi không focus, gõ thì là số thuần.
 * Giữ giá trị là `number | null` — không bao giờ để chuỗi lọt ra ngoài.
 */
export function MoneyInput({
  value, onChange, ...rest
}: { value: number | null | undefined; onChange: (v: number | null) => void } & Omit<InputHTMLAttributes<HTMLInputElement>, 'value' | 'onChange' | 'type'>) {
  return (
    <div className="relative">
      <input
        type="number"
        inputMode="numeric"
        min={0}
        step={1000}
        className={`${inputClass} pr-8`}
        value={value ?? ''}
        onChange={(e) => {
          const raw = e.target.value
          if (raw === '') return onChange(null)
          const n = Math.round(Number(raw))
          onChange(Number.isFinite(n) && n >= 0 ? n : null)
        }}
        {...rest}
      />
      <span className="pointer-events-none absolute inset-y-0 right-3 flex items-center text-xs text-ink-muted">₫</span>
    </div>
  )
}
